import React from 'react';
import { Section } from './ui/Section';
export function Bonuses() {
  const bonuses = [{
    code: 'B1',
    title: 'Mapa de Sustitución 1:1',
    desc: 'Cambia esto por esto. La guía visual para reemplazar cualquier ingrediente con gluten en 30 segundos.',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/e564f364-bcf6-44ea-9d57-8019182cc2f4.jpg'
  }, {
    code: 'B2',
    title: 'Ruta de Compra Sin Harinas',
    desc: 'Qué comprar en Mercadona, Lidl y Carrefour. Los 30 productos trampa que sabotean el proceso.',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/75052641-1d3a-48a3-a1cb-6c6898250b25.jpg'
  }, {
    code: 'B3',
    title: 'Planificador 7x3',
    desc: '21 comidas resueltas. El sistema semanal para no improvisar nunca con hambre ni cansancio.',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/3daae46a-0af3-431f-a6d5-2e7a7690d783.jpg'
  }, {
    code: 'B4',
    title: 'Kit SOS Antojos',
    desc: '20 rescates en menos de 10 minutos y los scripts mentales para los momentos más difíciles.',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/e10cc375-cb90-40df-9743-92e3b5e8d592.jpg'
  }, {
    code: 'B5',
    title: 'Guía Social Sin Gluten',
    desc: 'Come fuera sin dar explicaciones. Protocolos para bares, bodas y Navidad en España.',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/e136b625-03c6-466a-8cbd-6c311ca2b766.jpg'
  }, {
    code: 'B6',
    title: 'Tracker de Desinflamación',
    desc: 'Mide tu cambio en 21 días. La evidencia visual del progreso que mantiene la motivación.',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/47ee0c80-5b36-4ef7-96c1-f08042f4bd58.jpg'
  }];
  return <Section variant="alt" data-id="element-28" data-mp="33ge4qvvexpkn">
      <div className="text-center mb-4" data-id="element-29" data-mp="33ja32lb6ag9m">
        <span className="inline-block bg-brand-secondaryLight text-brand-secondaryHover font-semibold text-xs uppercase tracking-wider rounded-full px-4 py-1.5" data-id="element-30" data-mp="npi1u6uclmq0">
          Incluido gratis
        </span>
      </div>
      <h2 className="font-display text-2xl md:text-4xl font-bold text-center mb-4 text-brand-title" data-id="element-31" data-mp="3chv41muq56l2">
        6 Bonos Exclusivos de Implementación
      </h2>
      <p className="text-center text-brand-textMuted mb-10 font-body max-w-xl mx-auto text-sm md:text-base" data-id="element-32" data-mp="3ljl6dnq59pxm">
        Las herramientas que hacen que el sistema funcione en tu vida real
        desde el día 1.
      </p>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-33" data-mp="2tsykoe0v7yhm">
        {bonuses.map((bonus, i) => <div key={i} className="bg-white border border-brand-border rounded-2xl overflow-hidden shadow-card" data-id="element-34" data-mp="2xt8q9pkqwmvy" data-mpi={i}>
            <div className="relative aspect-[4/3] overflow-hidden" data-id="element-35" data-mp="32s227dkdw5u0">
              <img src={bonus.img} alt={bonus.title} className="w-full h-full object-cover" loading="lazy" data-id="element-36" data-mp="37jjvrgk2v44y" />
              <div className="absolute top-3 left-3 w-8 h-8 rounded-full bg-white/90 text-brand-primary font-heading font-bold flex items-center justify-center text-xs shadow-card" data-id="element-37" data-mp="2a4z9j22e2pbo">
                {bonus.code}
              </div>
            </div>
            <div className="p-5" data-id="element-38" data-mp="27j89h0btb7v5">
              <h3 className="font-heading text-base font-bold text-brand-title mb-1.5" data-id="element-39" data-mp="22l6fhkculo4w">
                {bonus.title}
              </h3>
              <p className="font-body text-brand-textMuted text-sm leading-relaxed" data-id="element-40" data-mp="1xkseundktggw">
                {bonus.desc}
              </p>
            </div>
          </div>)}
      </div>
    </Section>;
}